module.exports = __webpack_public_path__ + "media/src/public/fonts/Intro-Bold-48c9dd6d4d95149ea0fdb718b30f2428.ttf";